import "core-js/modules/es6.array.for-each";
import { useState, useLayoutEffect } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import { getTargetElement } from '../utils/dom';

function useSize(target) {
  var _useState = useState(function () {
    var el = getTargetElement(target);
    return {
      width: (el || {}).clientWidth,
      height: (el || {}).clientHeight
    };
  }),
      state = _useState[0],
      setState = _useState[1];

  useLayoutEffect(function () {
    var el = getTargetElement(target);

    if (!el) {
      return function () {};
    }

    var resizeObserver = new ResizeObserver(function (entries) {
      entries.forEach(function (entry) {
        setState({
          width: entry.target.clientWidth,
          height: entry.target.clientHeight
        });
      });
    });
    resizeObserver.observe(el);
    return function () {
      resizeObserver.disconnect();
    };
  }, [typeof target === 'function' ? undefined : target]);
  return state;
}

export default useSize;